import { Resource } from "i18next";

//FR
import MainFr from './fr/main.json';
import ComponentsFr from './fr/components.json';
import FormsFr from './fr/forms.json';

//EN
import MainEn from './en/main.json';
import ComponentsEn from './en/components.json';
import FormsEn from './en/forms.json';

export const resource: Resource = {
    fr: {
        main: MainFr,
        components: ComponentsFr,
        forms: FormsFr
    },
    en: {
        main: MainEn,
        components: ComponentsEn,
        forms: FormsEn
    }
}